var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.2 6.5L8.5735 4.55L5.2 2.6V6.5ZM12.714 1.4105C12.7985 1.716 12.857 2.1255 12.896 2.6455C12.9415 3.1655 12.961 3.614 12.961 4.004L13 4.55C13 5.9735 12.896 7.02 12.714 7.6895C12.5515 8.2745 12.1745 8.6515 11.5895 8.814C11.284 8.8985 10.725 8.957 9.867 8.996C9.022 9.0415 8.2485 9.061 7.5335 9.061L6.5 9.1C3.7765 9.1 2.08 8.996 1.4105 8.814C0.8255 8.6515 0.4485 8.2745 0.286 7.6895C0.2015 7.384 0.143 6.9745 0.104 6.4545C0.0585001 5.9345 0.039 5.486 0.039 5.096L0 4.55C0 3.1265 0.104 2.08 0.286 1.4105C0.4485 0.8255 0.8255 0.4485 1.4105 0.286C1.716 0.2015 2.275 0.143 3.133 0.104C3.978 0.0584999 4.7515 0.039 5.4665 0.039L6.5 0C9.2235 0 10.92 0.104 11.5895 0.286C12.1745 0.4485 12.5515 0.8255 12.714 1.4105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.cae47ffc6e2bce8831929f0ddf9fd200.svg";
export { ForwardRef as ReactComponent };